import {createAsyncThunk} from '@reduxjs/toolkit';

import {IRpcDeleteResponse} from 'shared/types/rpc';

import {REPORT_CONFIGURATION_SLICE} from '../report-configuration-constants';

import {
    deleteDrillDownReferenceRulesRequest,
    TDrillDownReferenceRuleDeleteRequestArgs,
    TDrillDownReferenceRulePostRequestArgs,
    TDrillDownReferenceRulePutRequestArgs,
    fetchDrillDownReferenceRules,
    postDrillDownReferenceRule,
    putDrillDownReferenceRule,
    IReportDdReferenceRule,
    IReportDdReferenceRulesFilter,
} from '.';

export const createDrilldownReferenceRule = createAsyncThunk<
    IReportDdReferenceRule,
    TDrillDownReferenceRulePostRequestArgs
>(
    `${REPORT_CONFIGURATION_SLICE}/createDrilldownReferenceRule`, async (args, {rejectWithValue}) => {
        try {
            const result = await postDrillDownReferenceRule(args);
            return result.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

export const editDrilldownReferenceRule = createAsyncThunk<IReportDdReferenceRule, TDrillDownReferenceRulePutRequestArgs>(
    `${REPORT_CONFIGURATION_SLICE}/editDrilldownReferenceRule`, async (args, {rejectWithValue}) => {
        try {
            const result = await putDrillDownReferenceRule(args);
            return result.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

export const deleteDrilldownReferenceRules = createAsyncThunk<
    IRpcDeleteResponse, TDrillDownReferenceRuleDeleteRequestArgs>(
        `${REPORT_CONFIGURATION_SLICE}/deleteDrilldownReferenceRule`, async (args, {rejectWithValue}) => {
            try {
                const result = await deleteDrillDownReferenceRulesRequest(args);
                return result.data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const loadDrilldownReferenceRules = createAsyncThunk<{
    ddReferenceRules: IReportDdReferenceRule[];
    recordsTotal: number;
}, IReportDdReferenceRulesFilter>(
    `${REPORT_CONFIGURATION_SLICE}/loadDrilldownReferenceRules`, async (args, {rejectWithValue}) => {
        try {
            const {data} = await fetchDrillDownReferenceRules(args);
            const {dataTable: ddReferenceRules, recordsTotal} = data;
            return {
                ddReferenceRules,
                recordsTotal,
            };
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);
